import { Component, Input, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { SharedService } from "@shared/services/shared.service";
import { EditBusinessComponent } from "../editBusiness/editBusiness.component";
import { BusinessService } from "app/services/business/business.service";
import { IBusinessView } from "app/models/business/business";
import { AuthService } from "@shared/auth/auth.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { ISelectItems } from "app/models/shared/shared";
import { EditBusinessInfoComponent } from "./editBusinessInfo/editBusinessInfo.component";
import { Subscription } from "rxjs";


@Component({
  selector: 'business-businessInfo',
  templateUrl: './businessInfo.component.html',
  styleUrls: ['./businessInfo.component.scss']
})

export class BusinessInfoComponent implements OnInit {

  @Input() businessId: number = 0;
  @Input() parentPanel: number = 0;

  sharedSubscription: Subscription;
  complaintCount: number = 0;
  commentCount: number = 0;
  currentBusiness: IBusinessView = {} as IBusinessView;
  currentTab: number = 0;
  registeredAgentFlag: boolean = false;
  isAdmin: boolean = false;
  showInformation: boolean = false;
  businessList: ISelectItems[] = [];

  constructor(
    private sharedService: SharedService,
    private authService: AuthService,
    private complaintService: ComplaintService,
    private businessService: BusinessService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    if (this.parentPanel == 0) {
      this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
        this.businessId = this.complaintService.currentComplaint.businessId;
        if (data == 2) {
          this.getBusinessInfo(this.businessId);
        }
      });
    }
    else if (this.parentPanel == 1) {
      this.businessId = this.businessService.businessId;
      if (this.businessId > 0)
        this.getBusinessInfo(this.businessId);
    }
    this.businessList = this.sharedService.businessTypeDropDownList;
    this.isAdmin = this.authService.userHasAtLeastOneRole(['Admin', 'Dev']);
  }

  ngOnDestroy() {
    if (this.parentPanel == 0){
      this.sharedSubscription.unsubscribe();
    }
  }

  getBusinessInfo(businessId: number) {
    this.businessService.getBusiness(businessId).subscribe(
      data => {
        this.currentBusiness = data;
        this.registeredAgentFlag = this.currentBusiness.parentBusinessId > 0;
        this.businessService.currentBusiness = this.currentBusiness;
        this.businessId = this.currentBusiness.id;
        this.businessService.updateTabs(this.businessService.businessTab);
      },
      error => this.sharedService.toastr.error("Could not get business data: " + error.message),
      () => { }
    );
  }

  editBusiness() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.data = { business: this.currentBusiness };
    const dialogRef = this.modalService.open(EditBusinessInfoComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getBusinessInfo(this.businessId);
          this.sharedService.toastr.success("Saved. ")
        }
      },
      error => this.sharedService.toastr.error("Could not get business data: " + error.message),
      () => { }
    );
  }

  refresh() {
    this.getBusinessInfo(this.businessId);
  }

  showInfo() {
    this.showInformation = !this.showInformation;
  }

  businessType(typeId: number) {
    if (typeId == null || typeId == undefined) {
      return '';
    }
    let type = this.businessList.find(x => x.value == typeId.toString());
    return type ? type.text : '';
  }

  admin() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = { business: this.currentBusiness,
                    newBusiness: false
     };
    const dialogRef = this.modalService.open(EditBusinessComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.sharedService.toastr.success("Saved. ");
        }
      },
      error => this.sharedService.toastr.error("Could not save data: " + error.message)
      ,
      () => { }
    );
  }


}